var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-audit-comment-h5tag" },
    [
      !_vm.hidden
        ? _c(
            "div",
            [
              _vm.label
                ? _c(
                    "div",
                    {
                      staticClass: "comment-title",
                      class: {
                        "comment-required":
                          _vm.required ||
                          _vm.needElecseal ||
                          _vm.needEsignature,
                      },
                    },
                    [_vm._v(_vm._s(_vm.label))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.schema != "default" ||
              (_vm.showCurComment && _vm.taskId && !_vm.isFinishedTask)
                ? [
                    _vm.checkboxOnly &&
                    _vm.mergeOptions.length === 1 &&
                    _vm.showInput
                      ? [
                          _c(
                            "van-row",
                            { staticClass: "comment-approval" },
                            [
                              _c(
                                "van-checkbox",
                                {
                                  attrs: {
                                    disabled: _vm.mergeOptions[0].disabled,
                                  },
                                  model: {
                                    value: _vm.approval_checkbox,
                                    callback: function ($$v) {
                                      _vm.approval_checkbox = $$v
                                    },
                                    expression: "approval_checkbox",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.mergeOptions[0].name))]
                              ),
                            ],
                            1
                          ),
                        ]
                      : [
                          _vm.mergeOptions.length && _vm.showInput
                            ? _c(
                                "van-radio-group",
                                {
                                  model: {
                                    value: _vm.approval,
                                    callback: function ($$v) {
                                      _vm.approval = $$v
                                    },
                                    expression: "approval",
                                  },
                                },
                                [
                                  _c(
                                    "van-row",
                                    { staticClass: "comment-approval" },
                                    _vm._l(
                                      _vm.mergeOptions,
                                      function (item, index) {
                                        return _c(
                                          "van-col",
                                          {
                                            key: index,
                                            staticClass: "comment-approval-col",
                                          },
                                          [
                                            _c(
                                              "van-radio",
                                              {
                                                attrs: {
                                                  name: item.id,
                                                  disabled: item.disabled,
                                                },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                    _vm._v(" "),
                    _vm.sample && _vm.showInput && !_vm.readonly
                      ? _c(
                          "van-row",
                          { staticClass: "comment-sample" },
                          [
                            _c(
                              "van-col",
                              {
                                staticClass: "comment-sample-label",
                                on: { click: _vm.showSample },
                              },
                              [
                                _vm._v("\n          常用意见 "),
                                !_vm.samplePopup
                                  ? _c("van-icon", {
                                      staticStyle: { "margin-left": "4px" },
                                      attrs: { name: "arrow-down" },
                                    })
                                  : _vm._e(),
                                _vm.samplePopup
                                  ? _c("van-icon", {
                                      staticStyle: { "margin-left": "4px" },
                                      attrs: { name: "arrow-up" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              {
                                staticClass: "comment-sample-label save-sample",
                                class: { disabled: !_vm.comment },
                                on: { click: _vm.saveSample },
                              },
                              [_vm._v("保存为常用意见")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showInput
                      ? _c("van-field", {
                          staticClass: "comment-text",
                          attrs: {
                            type: "textarea",
                            placeholder: _vm.placeholder,
                            autosize: _vm.autosize,
                            maxlength: _vm.maxlength,
                            readonly: _vm.readonly,
                          },
                          model: {
                            value: _vm.comment,
                            callback: function ($$v) {
                              _vm.comment =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "comment",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.getSealLoading
                      ? [
                          (_vm.elecseal || _vm.esignature) &&
                          _vm.signatureType == "4"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "e-mb-signature-wrap" },
                                  [
                                    _c("nuo-seal", {
                                      ref: "nuoSeal",
                                      attrs: {
                                        sealConfigData: _vm.sealConfigData,
                                        "nuo-seal": _vm.nuoSeal,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : (_vm.elecseal || _vm.esignature) &&
                              _vm.signatureType == "3" &&
                              _vm.hasLoaded
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "e-mb-signature-wrap" },
                                  [_c("e-seal", { ref: "eSeal" })],
                                  1
                                ),
                              ]
                            : [
                                _vm.signatureType == "1"
                                  ? [
                                      _vm.elecseal || _vm.esignature
                                        ? _c(
                                            "div",
                                            { staticClass: "chapter-wraper" },
                                            [
                                              _vm._l(
                                                _vm.chapterUrl,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "chapter-item",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "chapter-img",
                                                        attrs: { src: item },
                                                      }),
                                                      _vm._v(" "),
                                                      !_vm.readonly
                                                        ? _c("a", {
                                                            staticClass:
                                                              "chapter-delete",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.delSeal(
                                                                  item,
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm.showChapterAdd
                                                ? _c("div", {
                                                    staticClass:
                                                      "chapter-item chapter-empty",
                                                    on: {
                                                      click: _vm.sealSelect,
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.signatureType == "2"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "chapter-wraper" },
                                        _vm._l(
                                          _vm.mbRenderPosArr,
                                          function (item) {
                                            return _c("div", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: item.visible,
                                                  expression: "item.visible",
                                                },
                                              ],
                                              key: item.pos,
                                              staticClass: "chapter-item",
                                              class: {
                                                "chapter-empty":
                                                  !item.hasChapter,
                                              },
                                              attrs: { id: item.pos },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.sealSelect(
                                                    item.pos
                                                  )
                                                },
                                              },
                                            })
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "show-common-opinions",
          style: { width: "100%" },
          attrs: { position: "bottom", "get-container": "body" },
          model: {
            value: _vm.samplePopup,
            callback: function ($$v) {
              _vm.samplePopup = $$v
            },
            expression: "samplePopup",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: { title: "常用意见" },
            on: {
              "click-right": function ($event) {
                _vm.samplePopup = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "right",
                fn: function () {
                  return [
                    _c("van-icon", { attrs: { name: "cross", size: "18" } }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _vm.defaultComments.length > 0
            ? [
                _c(
                  "ul",
                  { staticClass: "comment-sample-box-m" },
                  _vm._l(_vm.defaultComments, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "comment-sample-item-m",
                        class: [{ active: item.active }],
                        attrs: { title: item.NAME },
                        on: {
                          click: function ($event) {
                            return _vm.chooseComment(item)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "sample-text-m" }, [
                          _vm._v(_vm._s(item.NAME)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : [_c("van-empty", { attrs: { description: "暂无数据" } })],
        ],
        2
      ),
      _vm._v(" "),
      _c("seal-modal", {
        ref: "sealModal",
        attrs: {
          chapterWID: _vm.chapterWID,
          elecseal: _vm.elecseal,
          esignature: _vm.esignature && _vm.signatureType == "1",
          signatureType: _vm.signatureType,
          needElecseal: _vm.needElecseal,
          needEsignature: _vm.needEsignature,
          clip: _vm.clip,
          multiple: _vm.multiple,
        },
        on: { "on-confirm": _vm.elecsealConfirm },
        model: {
          value: _vm.chapterPopup,
          callback: function ($$v) {
            _vm.chapterPopup = $$v
          },
          expression: "chapterPopup",
        },
      }),
      _vm._v(" "),
      _c("second-verification", {
        on: { "on-pass": _vm.onVerifyPass },
        model: {
          value: _vm.secondVerModal,
          callback: function ($$v) {
            _vm.secondVerModal = $$v
          },
          expression: "secondVerModal",
        },
      }),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "nuo-seal-dialog",
          style: { height: "22%" },
          attrs: {
            position: "bottom",
            closeable: "",
            "close-on-click-overlay": false,
          },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c(
            "div",
            { staticClass: "del-btns" },
            [
              _c("div", { staticClass: "del-btns-top" }, [_vm._v("电子签章")]),
              _vm._v(" "),
              _c("van-divider"),
              _vm._v(" "),
              _vm.isSuccess
                ? _c("div", { staticClass: "del-btns-bottom" }, [
                    _c("div", { staticClass: "check-icon-succ-m" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "check-text-m text-success" }, [
                      _vm._v("验签成功"),
                    ]),
                  ])
                : _c("div", { staticClass: "del-btns-bottom" }, [
                    _c("div", { staticClass: "check-icon-fail-m" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "check-text-m text-fail" }, [
                      _vm._v("验签失败"),
                    ]),
                  ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }